import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "../../util/axiosConfig";
import CategoryPicker from "../../component/CategoryPicker";
import TiptapEditor from "../../component/TiptapEditor";
import "../../assets/css/container/board/WriteNew.css";

function WriteNew() {
    const navigate = useNavigate();
    const [title, setTitle] = useState("");
    const [category, setCategory] = useState("");
    const [content, setContent] = useState("");
    const [files, setFiles] = useState<File[]>([]);
    const [saving, setSaving] = useState(false);

    const addAttachment = (file: File) => {
        if (files.length >= 5 || file.size > 10 * 1024 * 1024) {
            alert("첨부파일은 최대 5개, 각 10MB까지 추가할 수 있습니다.");
            return;
        }
        setFiles(previous => [...previous, file]);
    };

    const handleSave = async () => {
        if (saving) return;
        if (!title.trim() || !category || !content.trim()) {
            alert("제목, 카테고리, 내용을 모두 입력해 주세요.");
            return;
        }
        setSaving(true);
        try {
            if (files.length) {
                const form = new FormData();
                form.append("title", title);
                form.append("category", category);
                form.append("content", content);
                files.forEach(file => form.append("files", file));
                await axios.post("/api/board/save-with-attachments", form);
            } else {
                await axios.post("/api/board/save", {title, category, content});
            }
            alert("게시글을 작성했습니다.");
            navigate("/");
        } catch (error) {
            console.error("게시글 저장 실패:", error);
            alert("게시글 저장에 실패했습니다.");
        } finally {
            setSaving(false);
        }
    };

    return <div className="WriteNew">
        <textarea className="SetTitle" placeholder="제목을 입력해 주세요" value={title} onChange={e => setTitle(e.target.value)} />
        <CategoryPicker value={category} onChange={setCategory} />
        <TiptapEditor content={content} onChange={setContent} onAttachmentSelected={addAttachment} />
        {files.length > 0 && <div className="PostAttachmentsEditor">
            <h3>첨부파일</h3>
            <ul>{files.map((file, index) => <li key={index}>{file.name} <button type="button" onClick={() => setFiles(files.filter((_, i) => i !== index))}>제거</button></li>)}</ul>
        </div>}
        <button className="WriteNewSaveBtn" onClick={handleSave} disabled={saving}>{saving ? "저장 중..." : "저장"}</button>
    </div>;
}

export default WriteNew;
